export const environment = {
    production: true,
    API_ENDPOINT: "https://apis.smartdukaan.com/",
    ONLINE_ORDER_ENDPOINT: "https://images.smartdukaan.com/orders/add",
    APP_URL: "app.smartdukaan.com",
    IMG_URL: "https://app.smartdukaan.com/document/",
    GA_TRACKING_ID: 'G-XTFQ1BWVN6'
};
